import { render } from "./SummaryBlock.vue?vue&type=template&id=7a8078f2&scoped=true"
import script from "./SummaryBlock.vue?vue&type=script&lang=js"
export * from "./SummaryBlock.vue?vue&type=script&lang=js"

import "./SummaryBlock.vue?vue&type=style&index=0&id=7a8078f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8078f2"],['__file',"resources/assets/components/WorkCalendar/SummaryBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a8078f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a8078f2', __exports__)) {
    api.reload('7a8078f2', __exports__)
  }
  
  module.hot.accept("./SummaryBlock.vue?vue&type=template&id=7a8078f2&scoped=true", () => {
    api.rerender('7a8078f2', render)
  })

}


export default __exports__